/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class liabilityjournal extends IceEntity {
  liability_journal_key: string = "";
  other_items_key: string = "";
  other_items_receiving_key: string = "";
  medical_service_key: string = "";
  service_payment_reference_key: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  last_name: string = "";
  tax_authority_key: string = "";
  src_key: string = "";
  src_type: IceTypes.SourceType.srcUndefined;
  coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  journal_date: any = NaN;
  journal_desc: string = "";
  journal_code: string = "";
  journal_note: string = "";
  cosmetic_option: boolean = false;
  quantity: number = 0.0;
  debit: number = 0.0;
  credit: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accounting_period_key: string = "";
  entry_type: IceTypes.journal_entry_type.jetGeneral;

  constructor(copy?: liabilityjournal) {
    super();

    if (copy != null) {
      this.liability_journal_key = copy.liability_journal_key;
      this.other_items_key = copy.other_items_key;
      this.other_items_receiving_key = copy.other_items_receiving_key;
      this.medical_service_key = copy.medical_service_key;
      this.service_payment_reference_key = copy.service_payment_reference_key;
      this.trans_account = copy.trans_account;
      this.account_type = copy.account_type;
      this.last_name = copy.last_name;
      this.tax_authority_key = copy.tax_authority_key;
      this.src_key = copy.src_key;
      this.src_type = copy.src_type;
      this.coa_type = copy.coa_type;
      this.journal_date = copy.journal_date;
      this.journal_desc = copy.journal_desc;
      this.journal_code = copy.journal_code;
      this.journal_note = copy.journal_note;
      this.cosmetic_option = copy.cosmetic_option;
      this.quantity = copy.quantity;
      this.debit = copy.debit;
      this.credit = copy.credit;
      this.record_version = copy.record_version;
      this.offline_record_status = copy.offline_record_status;
    }
  }

  gettablename(): string {
    return "LIABILITY_JOURNAL";
  }
}
